export const INCREMENTS_COUNTER = "INCREMENTS_COUNTER";
export const DECREMENTS_COUNTER = "DECREMENTS_COUNTER";
export const RESET_COUNTER = "RESET_COUNTER";
export const FETCH_TEXT = "FETCH_TEXT";
export const GET_TODOS = "GET_TODOS";

export const UPDATE = "ACTUALIZAR";
export const DELETE = "ELIMINAR";
export const CREATE = "GUARDAR";